import { Check } from 'lucide-react';
import type { CarouselStyleDto } from '../../lib/api';
import { cn } from '../../lib/cn';
import { haptic } from '../../lib/tma';

export interface StyleGridProps {
  styles: CarouselStyleDto[];
  value: string | null;
  onChange: (code: string) => void;
  /** When given and the style has a rendered deck, a tap opens the preview instead of selecting. */
  onPreview?: (style: CarouselStyleDto) => void;
}

export function StyleGrid({ styles, value, onChange, onPreview }: StyleGridProps) {
  return (
    <div className="grid grid-cols-3 gap-2">
      {styles.map((s) => {
        const active = s.code === value;
        return (
          <button
            key={s.code}
            type="button"
            onClick={() => {
              haptic('light');
              if (onPreview && s.preview_urls.length > 0) onPreview(s);
              else onChange(s.code);
            }}
            className={cn(
              'flex flex-col rounded-2xl overflow-hidden bg-tg-section-bg text-left transition-[transform,box-shadow] duration-150 active:scale-[0.98]',
              active ? 'ring-2 ring-brand' : 'ring-1 ring-transparent',
            )}
            aria-pressed={active}
          >
            <div className="relative aspect-[4/5] w-full bg-tg-bg">
              {s.preview_url ? (
                <img
                  src={s.preview_url}
                  alt={s.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-xs text-tg-hint">
                  {s.name}
                </div>
              )}
              {active && (
                <span className="absolute top-1.5 right-1.5 w-6 h-6 rounded-full bg-brand text-brand-on flex items-center justify-center">
                  <Check size={14} />
                </span>
              )}
            </div>
            <span className="px-2 py-1.5 text-xs font-medium leading-tight">{s.name}</span>
          </button>
        );
      })}
    </div>
  );
}
